/**
 * Generate an ICS calendar event string for a single activity
 */
function activityToVEvent(activity) {
  const timestamp = activity.timestamp?.toDate ? activity.timestamp.toDate() : new Date(activity.timestamp);
  const dateStr = formatICSDate(timestamp);
  const uid = `${activity.id || activity.docId || Date.now()}@lightway-app`;

  const description = [
    activity.reflection || '',
    '',
    `Cause: ${activity.cause?.title || 'Unknown'}`,
    activity.cause?.level?.title ? `Level: ${activity.cause.level.title}` : ''
  ].filter(Boolean).join('\\n');

  return [
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTART;VALUE=DATE:${dateStr}`,
    `DTEND;VALUE=DATE:${dateStr}`,
    `SUMMARY:${escapeICS(activity.title)}`,
    `DESCRIPTION:${escapeICS(description)}`,
    'CATEGORIES:Lightway Advocacy',
    'END:VEVENT'
  ].join('\r\n');
}

/**
 * Format a Date object as ICS date string (YYYYMMDD)
 */
function formatICSDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

/**
 * Escape special characters for ICS format
 */
function escapeICS(text) {
  if (!text) return '';
  return text
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '');
}

/**
 * Generate a complete .ics file content
 */
function generateICSContent(events) {
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Lightway//Advocacy App//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'X-WR-CALNAME:Lightway Advocacy Activities',
    ...events,
    'END:VCALENDAR'
  ].join('\r\n');
}

function sanitizeFilename(name) {
  return (name || 'activity')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .substring(0, 30);
}

function triggerDownload(content, filename) {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Download a single activity as .ics file
 */
export function downloadActivityICS(activity) {
  const vevent = activityToVEvent(activity);
  const content = generateICSContent([vevent]);
  triggerDownload(content, `lightway-${sanitizeFilename(activity.title)}.ics`);
}

/**
 * Download multiple activities as a single .ics file
 */
export function downloadAllActivitiesICS(activities) {
  if (!activities || activities.length === 0) return;
  const vevents = activities.map(activityToVEvent);
  const content = generateICSContent(vevents);
  triggerDownload(content, 'lightway-all-activities.ics');
}
